export const state = {
    consignees: [],
    systemConsignee: []
  };
  export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/state.js